
import Request from '@/api/request';

export const postLoginOtp = async (username, { otp, country = 'CN' }) => {
  let params = { username, country };
  if (otp) params.otp = otp;
  return await Request.formpost('/v1/auth/login/otp', params).then((res) => {
    return res;
  });
};

export const postLogin = async (username, { password, country = 'CN' }) => {
  let params = { username, country };
  if (password) params.password = password;
  return await Request.formpost('/v1/auth/login', params).then((res) => {
    console.log('postLogin res', res);
    return res;
  });
};

export const putInitPwd = async (password) => {
  let params = {
    password  : password,
  }
  return await Request.put('/v1/users/me/auth/initpwd', params).then((res) => {
    return res;
  });
};

export const chgpwd = async (password, newPassword) => {
  let params = {
    password    : password,
    newpassword : newPassword,
  }
  return await Request.put('/v1/users/me/auth/chgpwd', params).then((res) => {
    return res;
  });
};

export const resetPwd = async (username, otp, password, country = 'CN') => {
  const params = {
    username: username,
    country: country,
    otp: otp,
    password: password,
  };
  return await Request.formpost('/v1/auth/resetpwd', params).then((res) => {
    return res;
  });
};

export const getAuthAccess = async () => {
  let params = {};
  return await Request.get('/v1/users/me/profile', params).then((res) => {
    return res;
  });
};

export const captchaImage = async () => {
  return await Request.get('/v1/captcha/image', {}).then((res) => {
    return res;
  });
}

export const postRegisterOtp = async (username, captchaid, captcha) => {
  let params = {
    username  : username,
    captchaid : captchaid,
    captcha   : captcha
  }

  return await Request.formpost('/v1/otp/register', params).then((res) => {
    return res;
  })
}

export const postBindOtp = async (username, captchaid, captcha) => {
  let params = {
    username  : username,
    captchaid : captchaid,
    captcha   : captcha
  }
  return await Request.formpost('/v1/otp/bind', params).then((res) => {
    return res;
  });
};
  
export const bindOtp = async (username, otp) => {
  let params = {
    username : username,
    otp      : otp,
  }
  return await Request.formpost('/v1/users/me/bind/oauth', params).then((res) => {
    return res;
  });
};

export const bindAuth = async (username, otp) => {
  let params = {
    username : username,
    otp      : otp,
  }
  return await Request.formpost('/v1/users/me/bind/auth', params).then((res) => {
    return res;
  });
};

export const postSigninOtp = async (username, captchaid, captcha) => {
  let params = {
    username  : username,
    captchaid : captchaid,
    captcha   : captcha
  }
  return await Request.formpost('/v1/otp/login', params).then((res) => {
    return res;
  });
};

export const postRestPwdOtp = async (username, captchaid, captcha) => {
  let params = {
    username  : username,
    captchaid : captchaid,
    captcha   : captcha
  }
  return await Request.formpost('/v1/otp/resetpwd', params).then((res) => {
    return res;
  });
};

export const signinOtp = async (username, otp) => {
  let params = {
    username : username,
    otp      : otp,
  }
  return await Request.formpost('/v1/auth/login/otp', params).then((res) => {
    return res;
  });
};

export const getWechatJsapi = async (url) => {
  let params = {
    url : url,
  }
  return await Request.get('/v1/wechat/oa/jsapiconfig', params).then((res) => {
    return res;
  });  
};

export const getUserProfile = async () => {
  return await Request.get('/v1/users/me/profile', {}).then((res) => {
    return res;
  })
} 